import React, { useEffect, useState } from "react";
import { Button, Input, Spin, Modal } from "antd"; // 👈 Modal add kiya
import Ticket from "../../../assests/images/ph_ticket-fill.png";
import Pen from "../../../assests/images/pen.png";
import { useDispatch } from "react-redux";
import { changeHeader } from "../../../redux/reducer/headerSlice";
import handlePost from "../../../utils/Post";
import { BASE_URL } from "../../../utils/config";
import AntDTable from "../../../components/table";
import handleGet from "../../../utils/Get";
import { RxCross2 } from "react-icons/rx";
import { AiOutlinePlus } from "react-icons/ai";

const { TextArea } = Input;

function Feedback() {
  const [createTicket, setCreateTicket] = useState(false);
  const [ticketDetail, setTicketDetail] = useState({ title: "", detail: "" });
  const [data, setData] = useState([]);
  const [tabManage, setTabManage] = useState({
    first: true,
    second: false,
    third: false,
  });
  const [loader, setLoader] = useState(true);
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(changeHeader(`${user.name}, Feedback & Support`));
  }, [user]);

  const fetchData = async (ticket) => {
    setLoader(true);
    const res = await handleGet(`${BASE_URL}${ticket}`);
    if (res) {
      setData(res.ticket || []);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData("ticket/user/pending/list");
  }, []);

  const handleCreateTicket = async () => {
    try {
      const success = await handlePost(`${BASE_URL}ticket/store`, ticketDetail);
      if (success) {
        setTicketDetail({ title: "", detail: "" });
        setCreateTicket(false); // Modal band ho jayega
        fetchData(
          tabManage.first
            ? "ticket/user/pending/list"
            : tabManage.second
              ? "ticket/user/open/list"
              : "ticket/user/closed/list"
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleTabClick = (tab) => {
    const newTabs = { first: false, second: false, third: false, ...tab };
    setTabManage(newTabs);
    if (newTabs.first) fetchData("ticket/user/pending/list");
    else if (newTabs.second) fetchData("ticket/user/open/list");
    else if (newTabs.third) fetchData("ticket/user/closed/list");
  };

  const handleCancel = () => {
    setCreateTicket(false);
    setTicketDetail({ title: "", detail: "" }); // Reset on cancel
  };

  return (
    <>
      {/* ===== MAIN PAGE (unchanged) ===== */}
      <div>
        <div className="flex justify-between items-center py-3 flex-wrap gap-2">

          {/* Left side - Tab buttons */}
          <div className="flex gap-2 flex-wrap">
            <Button
              size="large"
              onClick={() => handleTabClick({ first: true })}
              className={`w-44 p-2 rounded-lg font-medium font-nunito ${tabManage.first
                  ? "bg-[#6C5DD3] text-white"
                  : "text-[#6B6B6B] bg-[#F3F3F3] dark:bg-dark-body dark:text-dark-text"
                }`}
            >
              Pending Tickets
            </Button>
            <Button
              size="large"
              onClick={() => handleTabClick({ second: true })}
              className={`w-32 p-2 rounded-lg font-medium font-nunito ${tabManage.second
                  ? "bg-[#6C5DD3] text-white"
                  : "text-[#6B6B6B] bg-[#F3F3F3] dark:bg-dark-body dark:text-dark-text"
                }`}
            >
              Open
            </Button>
          </div>

          {/* Right side - New Ticket button */}
          <Button
            size="large"
            onClick={() => setCreateTicket(true)}
            icon={<AiOutlinePlus size={18} />} 
            className="bg-[#6C5DD3] hover:bg-[#5a4bbf] text-white font-medium font-nunito flex items-center gap-1 px-5 rounded-lg"
          >
            New Ticket
          </Button>

        </div>

        <div className="w-full h-full dark:bg-dark dark:border dark:border-[#334155] bg-theme-white p-2 rounded-xl min-h-[450px]">
          {loader ? (
            <div className="flex items-center justify-center h-full">
              <Spin size="large" />
            </div>
          ) : (
            <AntDTable
              link="/user"
              loader={loader}
              data={data}
              tabManage={tabManage}
              fetchData={fetchData}
            />
          )}
        </div>
      </div>

      {/* ===== ANT DESIGN MODAL ===== */}
      <Modal
        open={createTicket}
        onCancel={handleCancel}
        footer={null}         // Custom footer use karein
        centered              // Screen ke center mein
        width={600}
        destroyOnClose        // Close hone par form reset ho jaye
      >
        {/* Modal Header */}
        <div className="flex items-center gap-4 mb-4">
          <img className="w-16 h-16" src={Ticket} alt="Ticket" />
          <div className="flex flex-col">
            <h2 className="text-2xl font-bold font-nunito dark:text-white">
              Create a new Ticket
            </h2>
            <p className="text-gray-400 font-nunito">
              Fill in the form below to create a new ticket
            </p>
          </div>
        </div>

        {/* Title Input */}
        <div className="mb-4">
          <p className="font-nunito text-gray-400">Ticket Title</p>
          <Input
            value={ticketDetail.title}
            onChange={(e) =>
              setTicketDetail({ ...ticketDetail, title: e.target.value })
            }
            size="large"
            placeholder="Example: I can't purchase anything"
          />
        </div>

        {/* Description Input */}
        <div className="mb-4">
          <p className="font-nunito text-gray-400">Long Description</p>
          <TextArea
            value={ticketDetail.detail}
            onChange={(e) =>
              setTicketDetail({ ...ticketDetail, detail: e.target.value })
            }
            rows={4}
            placeholder="Example: I can't purchase anything"
          />
        </div>

        {/* Footer Buttons */}
        <div className="grid grid-cols-2 gap-2 mt-4">
          <Button
            size="large"
            onClick={handleCancel}
            className="h-12 bg-dark-text flex items-center justify-center gap-2"
          >
            <RxCross2 size={20} />
            Cancel
          </Button>
          <Button
            size="large"
            onClick={handleCreateTicket}
            className="flex items-center justify-center gap-2 bg-hoverUser dark:bg-dark-button-color text-white font-nunito rounded-lg"
          >
            <img className="h-5" src={Pen} alt="pen" style={{ width: "15px" }} />
            Create
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default Feedback;